import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

    :root {
        
        

    }
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        background: var(--background);
    }

    body, input, textarea, button {
        font-family: 'Lato', sans-serif;
        font-weight: 400;
    }

    h1, h2, h3, h4, h5, h6, strong {
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.25px;
    }
    a {
        text-decoration: none;
    }

    html {
        overflow: hidden;
        @media (min-width: 1280px){
            font-size: 12px;
        }
        @media (min-width: 1440px){
            font-size: 14px;
        }
        @media (min-width: 1920px){
            font-size: 16px;
        }
        @media (max-width: 1280px){
            font-size: 12px;
        }
        @media (max-width: 840px){
            font-size: 10px;
        }
    }

    button {
        cursor: poLato;
    }

    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }

    .react-modal-overlay {
        background: rgba(0, 0, 0, 0.5);

        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;

        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .react-modal-content {
        width: 100%;
        max-width: 576px;
        background: var(--background);
        padding: 3rem;
        position: relative;
        border-radius: 0.25rem;
    }

    .react-modal-close {
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        border: 0;
        background: transparent;
        transition: filter 0.3s;

        &:hover {
            filter: brightness(0.8);
        }
    }
`;